import { Transaction, useTransaction } from '@web/walter-lib/stream'
import { useEffect, useState } from 'react'
import { Steps, SwapOrConvertTransaction } from '.'
import { useIgnoreTxNotificationsStore } from '~store/ignoreTxNotifications'

export const useData = () => {
    const { startIgnoreId, stopIgnoreId } = useIgnoreTxNotificationsStore()
    const [step, setStep] = useState(Steps.selectSwap)
    const [tx, setTx] = useState<Transaction | null>(null)
    const [swapTransaction, setSwapTransaction] = useState<SwapOrConvertTransaction | null>(null)

    const { data: updatedTransaction } = useTransaction()

    const updatedTransactionId =
        updatedTransaction?.meta?.instant_exchange?.id || updatedTransaction?.meta?.id || updatedTransaction?.id

    const [fromPair, toPair] = swapTransaction?.convertPair || []
    const isTransactionConvertedPair =
        fromPair === updatedTransaction?.native?.tx_id &&
        toPair === updatedTransaction?.linked_transactions?.find(item => item.native?.tx_id === toPair)?.native?.tx_id

    // network swaps (e.g. chain switch to/from a different network) arrive as type WITHDRAW/DEPOSIT
    // with one of these subtypes rather than type SWAP/OTC
    const isSwapTransaction =
        ['SWAP', 'OTC'].includes(updatedTransaction?.type || '') ||
        ['CHAIN_SWITCH_TO', 'CHAIN_SWITCH_FROM', 'INSTANT_EXCHANGE'].includes(updatedTransaction?.subtype || '')

    useEffect(() => {
        if (
            isTransactionConvertedPair ||
            (isSwapTransaction &&
                swapTransaction?.id &&
                updatedTransactionId &&
                updatedTransactionId === swapTransaction.id)
        ) {
            updatedTransaction?.status && setSwapTransaction(prev => ({ ...prev, status: updatedTransaction?.status }))
            setTx(updatedTransaction)
        }
    }, [updatedTransactionId, swapTransaction?.id, isTransactionConvertedPair, updatedTransaction, isSwapTransaction])

    //ignore swap transaction if user on the progress/success screen
    useEffect(() => {
        const stopIgnoreNotifications = () => {
            stopIgnoreId(String(swapTransaction?.id))
            stopIgnoreId(fromPair)
        }

        if (swapTransaction?.id) {
            startIgnoreId(String(swapTransaction?.id))
        } else if (fromPair) {
            startIgnoreId(fromPair)
        }

        //if user closes the swap status screen, stop ignore notifications
        if (step === Steps.selectSwap) {
            stopIgnoreNotifications()
        }

        return () => {
            stopIgnoreNotifications()
        }
    }, [swapTransaction?.id, fromPair, startIgnoreId, stopIgnoreId, step])

    return { step, setStep, tx, setTx, swapTransaction, setSwapTransaction }
}
